var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","small":""},on:{"click":_vm.handleGetAssetReport}},[(_vm.isLoading)?_c('Loader',{attrs:{"size":"small","color":this.loaderColor,"text":""}}):_vm._e(),_vm._v(" Asset Report (PDF) ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }